import { formatDate, splitDateString } from './date_helpers';

const formFields = [
  'term_preferences',
  'occupation',
  'date_of_birth',
  'profile_photo',
  'gender',
  'hide_age',
  'advertiser_role',
];

function formatData(userData) {
  const dateAvailable = userData.term_preferences?.date_available;
  const data = {};

  // filter api response to get just values needed for form
  Object.entries(userData).forEach(([key, value]) => {
    if (formFields.includes(key)) {
      data[key] = value;
    }
  });

  // set to empty string if no date value
  if (userData.term_preferences && !dateAvailable) {
    data.term_preferences.date_available = '';
  }

  if (userData.date_of_birth) {
    data.split_date_of_birth = splitDateString(userData.date_of_birth);
  }

  return data;
}

function formatDateOfBirth(payload) {
  if (
    payload.split_date_of_birth &&
    (!payload.split_date_of_birth.day ||
      !payload.split_date_of_birth.month ||
      !payload.split_date_of_birth.year)
  ) {
    return payload;
  }

  if (payload.split_date_of_birth) {
    payload.date_of_birth = formatDate(payload.split_date_of_birth);
  }

  return payload;
}

function formatPayload(data) {
  let payload = JSON.parse(JSON.stringify(data));
  delete payload.profile_photo;

  // invert length of stay if min term is greater than max
  if (
    data.term_preferences &&
    data.term_preferences.min_term &&
    data.term_preferences.max_term &&
    data.term_preferences.min_term > data.term_preferences.max_term
  ) {
    payload.term_preferences.min_term = data.term_preferences.max_term;
    payload.term_preferences.max_term = data.term_preferences.min_term;
  }

  payload = formatDateOfBirth(payload);

  delete payload.split_date_of_birth;

  return payload;
}

export { formatData, formatPayload };
